<template>
<div>
  <v-select
    :items="dsAgendaVisitasCombo"
    label="Distribuidor"
    dense
    outlined
    :readonly="readon"
    chips
    :loading="loadingAgenda ? '#fe5000' : false"
    :disabled="loadingAgenda"
    @change="datos(selectedItem.vendedor)"
    :item-text="(item) => `${item.Nombre} [Dist:${item.vendedor}]`"
    item-value="vendedor"
    v-model="selectedItem"
    return-object
    hide-details
    :menu-props="{ top: false, offsetY: true }"
  >
    <template #selection="{ item }">
      <v-chip 
      small
      color="primary mt-1 ml-n1 font-weight-bold" label :disabled="dsAgendaVisitas.length === 0">
        <v-icon left size="18"> mdi-check </v-icon>
        {{ `${item.Nombre} (Dist: ${item.vendedor})` }}</v-chip
      >
    </template>
  </v-select>
</div>
  
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
export default {
  data() {
    return {
      dataCombo: [],
      vendedor: 1,
    };
  },
  computed: {
    ...mapState("mod_agendaquery", ["dsAgendaVisitasCombo", "idCliente", "dsAgendaVisitas", "loadingAgenda"]),
    selectedItem: {
      get() {
        return this.idCliente;
      },
      set(value) {
        this.set_idCliente(value);
      },
    },
  },
  mounted() {
    this.cargarDatosCombo();
    // console.log("mounted agenda");
  },

  methods: {
    ...mapActions("mod_agendaquery", ["agendaVisitas"]),
    ...mapMutations(["setTabAgenda"]),
    ...mapMutations("mod_agendaquery", [
      "set_idCliente",
      "set_loadingAgenda","clr_dsAgendaVisitas",
      "clr_filterAgendaVisit",
      
      "clr_filterAgendatipo",
      "clr_filterAgendaciudad",
    ]),
    async datos(idv) {
      this.set_loadingAgenda(true);
      this.clr_dsAgendaVisitas();
      this.clearFilter();
      
      await this.agendaVisitas({ vendedor: idv, opc: 1 });

      if (this.$route.name !== `AgendaVista`) {
        this.$router.push({ path: `/agenda/` }).catch((err) => {});
 this.setTabAgenda(0);
      }
    },
    async cargarDatosCombo() {
      await this.agendaVisitas({ opc: 0 });
    },
    clearFilter() {
      this.clr_filterAgendaVisit();
      this.clr_filterAgendatipo();
      this.clr_filterAgendaciudad();
    },
  },
  props: {
    readon: Boolean,
  },
};
</script>

